import moment from 'moment';

export const required = value => !value;

export const password = value =>
  !!(
    value &&
    !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#~^)(_+.,?!@$%^&*-]).{8,12}$/i.test(value)
  );

export const isUrl = value => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return pattern.test(value);
};

export const email = value => !!(value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value));

export const date = value => !!(value && !moment(value, 'L', true).isValid());

export const maxLength = max => value => !!(value && value.length > max);

export const minLength = min => value => !!(value && value.length < min);

export const onlyNumbers = value => !!(value && !/^[0-9]*$/i.test(value));

export const alphabets = value => !!(value && !/^[a-zA-Z]*$/i.test(value));
export const totalHrs = value => !!(value && !/([0-9]|[0-9][0-9]):[0-5][0-9]*$/i.test(value));
export const USZip = value => !!(value && !/^\d{5}$/i.test(value));
export const MobileNo = value => !!(value && !/^\d{10}$/i.test(value));

export const normalizeDate = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 2) {
      return `${onlyNums}/`;
    }
    if (onlyNums.length === 4) {
      return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2)}/`;
    }
  }
  if (onlyNums.length <= 2) {
    return onlyNums;
  }
  if (onlyNums.length <= 4) {
    return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2)}`;
  }
  return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 4)}/${onlyNums.slice(4, 8)}`;
};

export const comparePassword = (value, allValues) =>
  !(allValues.Password && value === allValues.Password);

export const compareUsername = (value, allValues) =>
  !(allValues.UserName && value === allValues.UserName);

export const requiredIfNoSSN = (value, allValues) => !(value || allValues.globalid);

export const requiredIfNoMemberId = (value, allValues) => !(value || allValues.MemberId);

export const trimVal = value => value && value.trim();

export const normalizeNumber = value => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^0-9]/g, '');
  if (onlyNums.length <= 2) {
    return onlyNums;
  }
  return `${onlyNums.slice(0, 2)}`;
};

export const normalizeZip = value => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^0-9]/g, '');
  if (onlyNums.length <= 2) {
    return onlyNums;
  }
  return `${onlyNums.slice(0, 10)}`;
};

export const validateMobileInput = eValue => {
  const onlyNums = eValue.replace(/[^0-9]/g, '');
  if (!eValue) {
    return eValue;
  }
  if (onlyNums.length < 10) {
    return onlyNums;
  }
  if (onlyNums.length === 10) {
    return onlyNums.replace(/(\d{3})(\d{3})(\d{4})/, '$1$2$3');
  }
  return onlyNums.slice(0, 10);
};
